import { setToken } from '@/commons/tools/auth';

const state = {
  common_info: {
    revision: null, // 版本号
  },
  token: null,
  driverMd5: null,
  userInfo: {
    user_id: '',
    user_type: '',
  },
  driverFid: null,
  policyDateStart: null,
  policyDateEnd: null,
};

// getters
const getters = {
  getCommonInfo: (state) => state.common_info,
  getToken: (state) => state.token,
  getDriverMd5: (state) => state.driverMd5,
  getUserInfo: (state) =>
    state.userInfo.user_id
      ? state.userInfo
      : JSON.parse(localStorage.getItem('userInfo')), // 获取基本信息，包含请求公共参数
  getDriverFid: (state) => state.driverFid,
  getPolicyDateStart: (state) => state.policyDateStart,
  getPolicyDateEnd: (state) => state.policyDateEnd,
};

// actions
const actions = {
  setCommonInfo({ commit }, { token, ...common_info }) {
    commit('saveCommonInfo', common_info);
    token && commit('saveToken', token);
  },
};

// mutations
const mutations = {
  saveCommonInfo(state, common_info) {
    state.common_info = common_info;
  },
  saveToken(state, token) {
    state.token = token;
    setToken(token); // localStoreage
  },
  saveDriverMd5(state, driverMd5) {
    state.driverMd5 = driverMd5;
  },
  // 存储基本信息
  saveUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  saveDriverFid(state, driverFid) {
    state.driverFid = driverFid;
  },
  savePolicyDateStart(state, policyDateStart) {
    state.policyDateStart = policyDateStart;
  },
  savePolicyDateEnd(state, policyDateEnd) {
    state.policyDateEnd = policyDateEnd;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
